<template>
    <v-col class="d-flex justify-center" cols="12" sm="auto" lg="auto" md="6">

      <v-card flat class="team-card" color="transparent">
        <v-img
          width="260px"
          height="260px"
          style="
            border-radius: 15px;
            border: 1px solid rgb(0 0 0 / 0.21) !important;
          "
          :src="user.photo"
        />
        <v-card-text class="pb-0 white--text pr-0">
          <v-col class="pa-0 d-flex justify-start flex-column">
            <span class="member--name">
              {{ user.name }}
              <span style="font-weight: bold">{{ user.lname }}</span>
            </span>
            <span class="member--pos">{{ user.pos }}</span>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>
</template>

<script>
export default {
  name: "TeamMemberCard",
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    navigateTo(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },
  },
};
</script>

<style>
</style>